export const defaultImage = '/region_header.jpg';

export const MIN_ROWS_DISPLAY_AD = 5;
